import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

interface ProfileSectionSkeletonProps {
  className?: string;
}

export const ProfileSectionSkeleton: React.FC<ProfileSectionSkeletonProps> = ({ className }) => (
  <Card className={className} aria-hidden="true">
    <CardHeader>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-4 w-4 bg-gray-200 rounded animate-pulse" />
          <div className="h-5 bg-gray-200 rounded animate-pulse w-36" />
        </div>
        <div className="h-9 bg-gray-200 rounded animate-pulse w-24" />
      </div>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[0, 1].map((i) => (
          <div key={i} className="space-y-2">
            <div className="h-3 bg-gray-200 rounded animate-pulse w-20" />
            <div className="h-10 bg-gray-200 rounded animate-pulse w-full" />
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[0, 1].map((i) => (
          <div key={i} className="space-y-2">
            <div className="h-3 bg-gray-200 rounded animate-pulse w-16" />
            <div className="h-10 bg-gray-200 rounded animate-pulse w-full" />
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);
